var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_172",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0068 0.00402832H0.000732422V100.411H90.0068V0.00402832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0779 17.1995C70.078 17.9814 70.39 18.7327 70.9451 19.2883C71.5001 19.8438 72.2529 20.1525 73.0378 20.1526H90.0056V92.97C90.0056 94.9458 89.2215 96.84 87.825 98.2395C86.4285 99.6286 84.5356 100.41 82.5613 100.41H7.37183C5.41755 100.41 3.5421 99.6388 2.15894 98.26C0.775756 96.8708 -0.000244141 94.9975 -0.000244141 93.0422V7.36157C-0.000244141 5.40642 0.774048 3.54325 2.15308 2.16431C3.53079 0.78545 5.40246 0.00329883 7.35132 0.00317383H70.0779V17.1995ZM25.4802 55.6907C24.6275 55.6907 23.9364 56.3891 23.9363 57.2356V73.8977C23.9363 74.7443 24.6274 75.4338 25.4802 75.4338H64.5281C65.3795 75.4338 66.071 74.7443 66.071 73.8977V57.2532C66.071 56.3891 65.3712 55.6907 64.5085 55.6907H61.3865C60.5239 55.6907 59.825 56.3891 59.825 57.2532V69.2629H30.1072V57.2356C30.107 56.3891 29.4165 55.6907 28.5652 55.6907H25.4802ZM45.8943 24.968C45.4964 24.9681 45.0955 25.122 44.7917 25.429L34.7771 35.4329C34.1765 36.0342 34.1765 37.02 34.7771 37.6213L36.9568 39.7961C37.5574 40.3972 38.5335 40.3973 39.1355 39.7961L42.7742 36.1497V59.9963C42.7742 60.8535 43.4736 61.5451 44.3367 61.5452H47.4597C48.3214 61.5452 49.0203 60.8535 49.0203 59.9963V36.0862L52.7039 39.7708C53.3001 40.3719 54.2677 40.3717 54.864 39.7708L57.0222 37.6077C57.6171 37.0192 57.6171 36.0477 57.0222 35.4592L46.9871 25.4163C46.686 25.122 46.2895 24.968 45.8943 24.968ZM83.5701 0.00317383C87.1242 0.00333464 90.0056 2.88504 90.0056 6.44556V20.1526L70.0779 0.00317383H83.5701Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.8e4afbdf315c0c328af8deb5f60ce3d2.svg";
export { ForwardRef as ReactComponent };